module.exports = __webpack_public_path__ + "static/media/1009873.57a61fbe.jpg";